import {
  Figcaption,
  Figure,
  Heading,
  Heading3,
  Heading4,
  Heading5,
  Heading6,
  MEDIA_QUERIES,
  P,
  TableContainer as Table,
} from '@student-coin/coinpaper-components';
import tw, { styled } from 'twin.macro';

export const DashedContainer = styled.div`
  ${tw`flex justify-center py-4 my-4 md:py-8 md:my-8`}
  border-top: ${({ theme }) => `1px dashed ${theme.colors.title}`};
  border-bottom: ${({ theme }) => `1px dashed ${theme.colors.title}`};
`;

export const TweetContainer = styled.div`
  width: 550px;
  max-width: 100%;
  margin: auto;
`;

export const OL = styled.ol`
  list-style: outside decimal;
  padding-left: 1.5rem;
`;

export const UL = styled.ul`
  list-style: outside;
  padding-left: 1.5rem;
`;

export const LI = styled.li`
  margin-left: 16px;
  margin-bottom: 15px;
  &:first-child {
    margin-top: 0 !important;
  }
  &:last-child {
    margin-bottom: 0;
  }
`;

export const Container = styled.div`
  ${tw`grid break-words grid-cols-12 md:grid-cols-10 lg:grid-cols-12`};

  ${Figure}, ${DashedContainer} {
    ${tw`col-start-1 md:col-start-1 col-span-12 md:col-span-10 lg:col-start-1 lg:col-span-12`};
  }

  ${Table} {
    ${tw`font-inter col-start-1 md:col-start-1 col-span-12 md:col-span-10 lg:col-span-8 lg:col-start-3`};
  }

  ${Heading}, ${Heading3}, ${Heading4}, ${Heading5}, ${Heading6} {
    ${tw`mt-8`}
    margin-bottom: 0.25rem;
  }

  ${Figcaption} {
    ${tw`pt-4`}
  }

  & > *:not(${TweetContainer}) {
    ${tw`col-start-1 sm:col-start-2 md:col-start-2 col-span-12 sm:col-span-12 md:col-span-9 lg:col-start-2 lg:col-span-11 xl:col-start-2 xl:col-span-11 2xl:col-start-2 2xl:col-span-10`};
  }

  & > ${P}, ${LI} {
    line-height: 180%;
    font-size: 18px;

    ${tw`font-lora my-2 md:my-3`};

    &:last-child {
      ${tw`mb-0`}
    }

    @media ${MEDIA_QUERIES.tablet} {
      font-size: 17px; // TODO replace with font-size 18px after investigation
    }
  }

  ${TweetContainer} {
    ${tw`col-start-1 md:col-start-1 col-span-12 md:col-span-10 lg:col-start-2 `};
  }
`;

export const ProsAndCons = styled.div`
  ${tw`grid grid-cols-1 md:grid-cols-2 gap-8`}
`;

export const PacItem = styled.div`
  ${tw`flex items-stretch mb-1.5 overflow-hidden font-lora`}
  line-height: 180%;
  font-size: 18px;
  @media ${MEDIA_QUERIES.tablet} {
    font-size: 17px;
  }
  svg {
    flex-shrink: 0;
    margin-top: 2px;
  }
  span {
    ${tw`ml-1.5`}
  }
`;

export const OverviewContainer = styled.div`
  h2 {
    margin-top: 10px !important;
  }
  & > div {
    padding-bottom: 25px;
  }
`;
